import { ModuleWithProviders, Provider } from '@angular/core';
import { DwMetadataService } from './metadata.service';
import { DwDocument } from './document';
import { DwReadService, DwCreateService, DwDeleteService, DwListService, DwUpdateService } from './service';
/**
 * Document Module
 *
 * @export
 */
var DwDocumentModule = /** @class */ (function () {
    function DwDocumentModule() {
    }
    DwDocumentModule.forRoot = function (providers) {
        return {
            ngModule: DwDocumentModule,
            providers: [
                DwMetadataService,
                DwDocument,
                DwReadService,
                DwCreateService,
                DwUpdateService,
                DwDeleteService,
                DwListService,
                { provide: 'DocumentID', useValue: '' },
                { provide: 'DocumentResource', useValue: '' }
            ].concat(providers)
        };
    };
    return DwDocumentModule;
}());
export { DwDocumentModule };
